<template>
  <section class="interior-hero" :style="getImageStyle">
    <div class="container">
      <div class="interior-hero__header">
        <div class="interior-hero__header-textblock">
          <h1 class="text-h1 interior-hero__header-title" v-html="getItem.title" />
          <div v-if="getItem.subtitle" class="text-inversed interior-hero__header-subtitle">
            <RichRenderer :richTextData="getItem.subtitle" :addWrapClass="false" />
          </div>
          <app-button
            v-if="showLearnMoreBtn"
            :id="learnMoreBtnId"
            :text="$t('product.admetox.headerDetailsBtn')"
            size="small"
            variant="transparent-white"
            type="button"
            class="interior-hero__header-btn"
            @clicked="$emit('scrollToDetailsRequested')"
          />
          <app-button
            v-if="contactBtn"
            :id="contactBtn.id"
            :url="contactBtn.url"
            :target="contactBtn.target"
            :text="contactBtn.title"
            size="middle"
            variant="green"
            type="link"
            class="interior-hero__header-btn--contact"
          />
        </div>
        <img
          v-if="!getItem.imageList && getItem.image"
          :src="getItem.image"
          class="interior-hero__header-image"
        />
        <div v-if="getItem.imageList && !getItem.image" class="general__images">
          <div v-if="getItem.imageList && getItem.imageList.length > 1" class="general__preview">
            <div
              v-for="(imageItem, imageItemIdx) in getItem.imageList"
              :key="`${imageItem.title}-${imageItemIdx}`"
              class="general__preview-wrapper"
              :class="{
                'general__preview-wrapper--active': activatedImg === imageItemIdx,
              }"
              @click="activateImg(imageItemIdx)"
            >
              <img :src="imageItem.url" :alt="imageItem.alt" class="general__preview-img" />
            </div>
          </div>
          <div class="general__img-wrapper">
            <zoom-on-hover
              :imgNormal="getActiveImage.url"
              :altText="getActiveImage.alt"
              :scale="3"
              class="general__img"
            />
          </div>
        </div>
      </div>
      <div class="interior-hero__body">
        <div class="main__items-wrapper">
          <router-link
            v-for="linkItem in list"
            :key="linkItem.slug"
            class="main__item"
            :to="linkItem.link"
          >
            <h4 class="text-h4 text-color-navy main__item-title" v-html="linkItem.title" />
            <p
              v-if="linkItem.tileDescription"
              class="main__item-descr text-paragraph"
              v-html="linkItem.tileDescription"
            />
          </router-link>
        </div>

        <div v-if="groupedListTitle" class="grouped-title" v-html="groupedListTitle" />
        <div v-if="groupedList" class="grouped-wrapper main__items-wrapper">
          <router-link
            v-for="groupedItem in groupedList"
            :key="groupedItem.slug"
            class="main__item"
            :to="groupedItem.link"
          >
            <h4 class="text-h4 text-color-navy main__item-title" v-html="groupedItem.title" />
            <p
              v-if="groupedItem.tileDescription"
              class="main__item-descr text-paragraph"
              v-html="groupedItem.tileDescription"
            />
          </router-link>
        </div>

        <div class="tabbed-graphic__container">
          <div v-if="tabbedGraphic?.paragraphRich" class="tabbed-graphic__rich-text">
            <RichRenderer :richTextData="tabbedGraphic.paragraphRich" />
          </div>
          <div v-if="tabbedGraphic?.tabs" class="tabbed-graphic">
            <div class="tabbed-graphic__tabs-wrapper">
              <div
                v-for="(tab, n) in tabbedGraphic.tabs"
                :key="n"
                class="tabbed-graphic__tab"
                :class="{ 'tabbed-graphic__tab--active': currentTab === n }"
                @click="selectTab(n)"
              >
                <div class="tabbed-graphic__tab-imgwrapper">
                  <img class="tabbed-graphic__tab-img" :src="tab.icon" :alt="tab.title" />
                </div>
                <div class="tabbed-graphic__tab-textwrapper">
                  <h4>{{ tab.title }}</h4>
                  <p>{{ tab.subtitle }}</p>
                </div>
              </div>
            </div>
            <div class="tabbed-graphic__content">
              <RichRenderer :richTextData="getTabContent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import bgDefault from '/static/images/banner.jpg'

import ZoomOnHover from '@/components/vendor/vue-zoom-on-hover/ZoomOnHover.vue'

export default {
  name: 'InteriorHero',
  components: {
    ZoomOnHover,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    tabbedGraphic: {
      type: Object,
      default: () => {},
    },
    groupedListTitle: {
      type: String,
      default: '',
    },
    groupedList: {
      type: Array,
      default: () => [],
    },
    showLearnMoreBtn: {
      type: Boolean,
      default: false,
    },
    learnMoreBtnId: {
      type: String,
      default: '',
    },
    contactBtn: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['scrollToDetailsRequested'],
  data() {
    return {
      activatedImg: 0,
      currentTab: 0,
    }
  },
  computed: {
    getImageStyle() {
      return this.item
        ? {
            'background-image': `linear-gradient(180deg, #008d9b, transparent), url(${
              this.item.heroImage ? this.item.heroImage : bgDefault
            })`,
            'background-repeat': 'no-repeat',
            'background-position': 'center',
          }
        : {}
    },
    getItem() {
      return this.item || {}
    },
    getTabContent() {
      return this.tabbedGraphic?.tabs?.[this.currentTab]?.paragraphRich
    },
    getActiveImage() {
      return this.getItem?.imageList?.find((el, idx) => this.activatedImg === idx)
    },
  },
  methods: {
    activateImg(item) {
      this.activatedImg = item
    },
    selectTab(n) {
      this.currentTab = n
    },
  },
}
</script>
